import { getAxiosInstance } from "../../../../np-rest/rest";
import { snackActions } from "../../../../sc-utilities/SnackBar";

export const fetchRaspberryEraseStationDebugLogsCount = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/debug-log-count", filterData);
            if(res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "warning",
                },
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "error",
                },
            });
            return [];
        }
        
    }

}

export const fetchRaspberryEraseStationDebugLogsList = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/debug-log-list", filterData);
            if(res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "warning",
                },
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "error",
                },
            });
            return [];
        }
        
    }

}

export const fetchRaspberryEraseStationDebugLogsDownload = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/debug-log-download", filterData);
            if(res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "warning",
                },
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle debug logs data."}`,
                options: {
                    variant: "error",
                },
            });
            return [];
        }
        
    }
    
}